import React, { useContext } from 'react';
import { Info, Repos, User, Search, Navbar } from '../components';
import loadingImage from '../images/preloader.gif';
import { GithubContext } from '../context/context';
const Dashboard = () => {
  const { isloading, githubUser } = useContext(GithubContext);

  if (isloading) {
    return (
      <main>
        <Navbar />
        <Search />
        <img src={loadingImage} alt='loading..' className='loading-img' />
      </main>
    );
  }

  return (
    <main>
      <Navbar />
      <Search />
      {githubUser.login && (
        <>
          <Info />
          <User />
          <Repos />
        </>
      )}
    </main>
  );
};

export default Dashboard;
